import {Realm} from "../environment/realm/realm";

export function $Uint32ArrayPrototype$(realm: Realm) {
	return realm["[[GlobalObject]]"].Uint32Array.prototype;
}
